import { StoreState } from '@/core/models/store.interface';
import { RoleKey } from '@nxtpeople/nxt-vue-library';
import { Module } from 'vuex';
import { POWER_BI_TOKEN_ENDPOINTS } from '../power-bi-tokens/power-bi-token.endpoints';
import { UserInfo } from './user-info.interface';
import { UserInfoService } from './user-info.service';

const service = new UserInfoService();

export interface UserInfoState {
   userInfo?: UserInfo;
   loadingUserInfo: boolean;
   userTokens: Array<string>;
}

const UserInfoStore: Module<UserInfoState, StoreState> = {
   namespaced: true,
   state: { loadingUserInfo: true, userTokens: [] },
   getters: {
      user(state: UserInfoState) {
         return state.userInfo;
      },
      permissions(state) {
         return state.userInfo?.scopes;
      },
      addons(state: UserInfoState) {
         return state.userInfo?.addons;
      },
      isContactUser(state) {
         return !!state.userInfo?.is_contact_user;
      },
      isPlatformAdmin(state) {
         return !!state.userInfo?.roles.find((role) => role.key === RoleKey.PlatformAdmin);
      },
   },

   mutations: {
      SET_USER(state: UserInfoState, userInfo: UserInfo) {
         state.userInfo = { ...state.userInfo, ...userInfo };
      },
      SET_LOADING_USER_INFO(state: UserInfoState, loading: boolean) {
         state.loadingUserInfo = loading;
      },
      SET_USER_TOKENS(state: UserInfoState, userTokens: Array<string>) {
         state.userTokens = userTokens;
      },
   },
   actions: {
      async getUser(context: any) {
         context.commit('SET_LOADING_USER_INFO', true);

         return await service
            .getUser()
            .then((user) => {
               const tempUsr = {
                  ...user,
                  roles: [
                     ...(user.roles ?? []),
                     {
                        id: 69,
                        key: 'etm-ventje',
                        name: 'ETM Ventje',
                        description: 'Role for ETM Ventje users',

                        module: {
                           id: 2,
                           key: 'nxt-pay',
                           name: 'NxtPay',
                           icon_path: 'https://nxtpeople-cdn.s3.eu-central-1.amazonaws.com/images/emblems/nxt-pay-emblem.png',
                           color: '#a600e3',
                        },
                        module_id: 2,
                     },
                  ],
               };
               context.commit('SET_USER', tempUsr);
               context.commit('permission/SET_PERMISSIONS', tempUsr.scopes, { root: true });
               context.commit('permission/SET_ROLES', tempUsr.roles, { root: true });

               return user;
            })
            .finally(() => {
               context.commit('SET_LOADING_USER_INFO', false);
            });
      },
      async changeUser(context: any, values: any) {
         return await service.patchUser(values).then((user: UserInfo) => {
            context.commit('SET_USER', user);
            context.commit('permission/SET_PERMISSIONS', user.scopes, { root: true });
            context.commit('permission/SET_ROLES', user.roles, { root: true });
            return user;
         });
      },
      async getUserTokens(context) {
         const { data: userTokens } = await http.get<Array<string>>(POWER_BI_TOKEN_ENDPOINTS.GET_USER_TOKENS());

         context.commit('SET_USER_TOKENS', userTokens);
      },
   },
};

export default UserInfoStore;
